var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `cv-breadcrumb-item ${_vm.carbonPrefix}--breadcrumb-item`,
    { [`${_vm.carbonPrefix}--breadcrumb-item--current`]: _vm.activePage },
  ],attrs:{"aria-current":_vm.ariaCurrent}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }